<template>
    <div class="about_page">
        <div id="exportable-content">
            <HeroLeft title="We're building a unified integration layer for SaaS applications" colour-index="1"
                :left="true"
                :subtitle="`Unified.to helps software teams ship integrations faster at any scale. We've grown to ${CATS.length} unified API categories, ${INTEGRATIONS_COUNT_10s}+ integrations, and ${OBJECTS_COUNT_100s}+ distinct data objects.`" />

            <section class="px-3 sm:px-28 mb-3 sm:mb-12 gradient-bl-to-bg">
                <div class="flex text-[var(--dark-gray)] justify-left flex-wrap lg:flex-nowrap lg:gap-24 sm:py-12">
                    <div class="lg:w-3/5 mb-12 lg:mb-0">
                        <h5 class="mb-4 mt-8">Our story</h5>

                        <p class="text-medium-gray">
                            Unified.to, backed by Techstars and Creative Destruction Lab, was started by CEO Roy Pereira
                            and
                            CTO Alexey Adamsky after decades of growing frustrations with traditional API integration
                            development.
                        </p>

                        <p class="mt-4 text-medium-gray">
                            We believe integrating with APIs should be as easy as an afternoon project. Any SaaS
                            company, at
                            any stage, should be able to connect to their customers' data across SaaS integrations to
                            power
                            automation,
                            insights, and better user experiences in their applications. Integrations don't have to cost
                            you
                            millions in engineering resources or derail your core product roadmap.
                        </p>

                        <p class="mt-4 text-medium-gray">
                            From that, Unified.to's next-generation real-time unified API platform was born. Our
                            customers
                            benefit from real-time data, 10x faster integration launches, and zero maintenance. Software
                            teams
                            are shipping integrations in days rather than years.
                        </p>

                    </div>

                    <div class="lg:w-2/5 mb-3 sm:mb-12 lg:mb-0">
                        <h5 class="mb-4 mt-8">Our mission</h5>

                        <p class="text-medium-gray">
                            We provide real-time access to customer data for modern SaaS companies, unlocking untapped
                            innovation and
                            growth
                            by removing the burden of API integration development.
                        </p>

                        <h5 class="mb-4 mt-8">Why is this important?</h5>
                        <!-- <h5 class="border-b-2 font-bold mb-4 mt-8">Why Is This Important?</h5> -->
                        <ul class="list-none ml-8 text-medium-gray">
                            <li>
                                <Icon name="ion:ios-checkmark-circle-outline" class="text-2xl -ml-8 mr-2" />
                                Modern SaaS and AI applications rely on access to customer data scattered
                                across
                                hundreds of APIs.
                            </li>
                            <li>
                                <Icon name="ion:ios-checkmark-circle-outline" class="text-2xl -ml-8 mr-2" />
                                Unified.to enables software teams to integrate once per category to support multiple
                                APIs in their
                                products.
                            </li>
                            <!-- <li>Luckily, all popular software vendors have APIs that can be accessed by 3rd-party software for their mutual customers.</li> -->
                        </ul>
                    </div>
                </div>

                <!-- <h5 class="mb-16 mt-8">Our leadership team</h5>

            <div :class="`grid sm:gap-20 sm:grid-cols-4 grid-cols-1`">
                <div class="w-full" v-for="person in TEAM">
                    <div class="mb-[70px]">
                        <div class="flex items-center justify-left rounded-xl  mb-12 text-primary">
                            <img :src="person.image_url" :alt="person.name" width="400" height="518" loading="lazy" decoding="async"
                                class="rounded-xl h-64 object-scale-down" />
                        </div>
                        <div class="box-title mb-5">
                            {{ person.name }}
                        </div>
                        <p class="box-description my-3 whitespace-nowrap">
                            {{ person.title }}
                            <a :href="person.linkedin_url" target="_blank"
                                class="text-primary-blue hover:text-[var(--secondary-blue)]">
                                <Icon name="mdi:linkedin-box" class="text-2xl" />
                            </a>
                        </p>
                    </div>
                </div>
            </div>-->
            </section>

            <Benefits center class="background" small title="Our leadership team" :benefits="TEAM.map(person => ({
                title: person.name,
                image_url: person.image_url,
                body: person.title
            }))" />

            <section class="px-3 sm:px-28 mb-3 sm:mb-12 gradient-bl-to-bg flex justify-center">
                <a href="/files/Unified.to_Brand_Assets.zip" target="_blank" class="btn btn-sm btn-primary">
                    Download Media Kit
                </a>
            </section>

            <Benefits center class="background" small title="In The News" :benefits="NEWS" />


            <Benefits center class="background" small title="Our Impact" :benefits="[
                {
                    image_40: true,
                    image_url: '/images/dark_oneeleven.png',
                    body: 'We\'re proud members of Toronto\'s premiere tech community.',
                },
                {
                    image_40: true,
                    image_url: '/images/dark_Techstars_Logo_Primary_Black.png',
                    body: 'We\'re honored to have been part of the Techstars Toronto accelerator 2023 cohort.',
                },
                {
                    image_40: true,
                    image_url: '/images/dark_upsidefoundation.png',
                    body: 'We\'ve pledged 1% of our equity to support the world-renowned Sick Kid\'s Hospital.',
                },

            ]" />

            <Benefits center small title="Our Awards" :benefits="[
                {
                    image_40: true,
                    image_url: '/images/awards/Best-Business-Software-API.jpg',
                    body: '2026 API:World\'s Best Business API'
                },
                {
                    image_40: true,
                    image_url: '/images/awards/dark_24_SXSW_Pitch-Finalist_web.png',
                    body: 'SXSW 2024 Pitch Finalist (Smart Data)',
                },
                {
                    image_40: true,
                    image_url: '/images/awards/dark_CIX_Top_20_Early_Award.png',
                    body: 'CIX 2024 Top 20 Early-stage innovative startup in Canada',
                },
                {
                    image_40: true,
                    image_url: '/images/awards/dark_devhunt.png',
                    body: 'DevHunt.com Product of the week (2024)',
                },
                {
                    image_40: true,
                    image_url: '/images/CDL-Atlantic_logo_white.png',
                    body: 'Creative Destruction Lab 2024 Prime graduate',
                },
                {
                    image_40: true,
                    image_url: '/images/Next-logo-1.png',
                    body: 'Next Canada \'Founders\' 2024',
                },
                {
                    image_40: true,
                    image_url: '/images/c100_nav-logo.svg',
                    body: 'C100 Fellows 2024/2025',
                }
            ]" />

            <Hero class="gradient-bg-to-bl" title="Unleash your full integration potential" colour-index="3"
                subtitle="Sign up in seconds and start building integrations today." :buttons="[
                    { link: 'https://app.unified.to', title: 'Get started' },
                    { link: '/contact', title: 'Talk to our team', icon: 'ic:round-keyboard-arrow-right' },
                ]" />
        </div>
    </div>
</template>
<style>
.about_page p {
    /* margin-bottom: 1rem; */
    line-height: 2rem;
}

.about_page li {
    line-height: 2rem;
}
</style>
<script setup lang="ts">
import type { IBenefit } from '~/components/Benefits.vue';
import { CATS, INTEGRATIONS_COUNT_10s, OBJECTS_COUNT_100s } from '~/services/integrations';

useSEO({
    title: 'About Us',
    description:
        "We're transforming the way developers integrate. We empower developers to build and launch API-first integrations in hours instead of months with one API and data model.",
});

const NEWS: IBenefit[] = [
    {
        title: 'Mar 03, 2026: Unified is scaling this one-to-many model with its new Assessment and Advertising APIs [API Changelog]',
        button_link: 'https://apichangelog.substack.com/p/2026-09',
        button_text: 'Read the article',
    },
    {
        title: 'December 8, 2025: Unified.to Powers 550% API Usage Growth in Six Months Amid Rising AI Adoption [Yahoo! Finance]',
        // image_40: true,
        // image_url: '/images/Yahoo!_Finance_logo_2021.png',
        button_link: 'https://ca.finance.yahoo.com/news/unified-powers-550-api-usage-120000495.html',
        button_text: 'Read the article',
    },
    {
        title: 'December 19, 2024: $1.4M CAD Raised to Build the Modern API Integrator [The SaaS Academy]',
        button_link: 'https://www.thesaasacademy.com/podcasts/the-saas-cfo/episodes/2148930413',
        button_text: 'Listen to the podcast',
    },
    {
        title: 'October 10, 2024: Unified.to Secures $1.1M CAD in Pre-Seed Round [The SaaS News]',
        button_link: 'https://www.thesaasnews.com/news/unified-to-secures-1-1m-cad-in-pre-seed-round',
        button_text: 'Read the article',
    },
    {
        title: 'October 7, 2024: Repeat founders return with $1.1 million to help AI SaaS companies launch API integrations through Unified.to [BetaKit]',
        button_link: 'https://betakit.com/calendarhero-team-returns-with-1-1-million-to-help-ai-saas-companies-launch-api-integrations-through-unified-to/',
        // image_url: '/images/betakit-logo-OG.png',
        button_text: 'Read the article',
    },
    {
        title: 'March 20, 2024: “Hustle and get traction” with Roy Pereira of Unified [Boast.ai]',
        button_link: 'https://www.boast.ai/en-ca/resources/podcasts/what-the-tech-episode-38-hustle-and-get-traction-with-roy-pereira-of-unified',
        button_text: 'Listen to the podcast',
    },
    {
        title: 'December 18, 2023: The guy who invented VPN is now working on a unified API [StartWell]',
        button_link: 'https://startwell.co/cdn/shop/files/StartWell-wordmark_white.jpg?v=1736289953&width=120',
        button_text: 'Read the article',
    },
    {
        title: 'November 2, 2023: Startup Success: What do our events mean to Unified.to\'s Roy Pereira? [WebSummit]',
        button_link: 'https://qatar.websummit.com/blog/startups-investors/startup-success-what-does-collision-mean-to-unified-tos-roy-pereira/',
        button_text: 'Read the article',
        // image_url: '/images/Web_Summit_logo.svg.png',
        // image_40: true,
    },
    {
        title: 'July 13, 2023: An API to abstract everything, with Roy Pereira from Unified.to [APIs You Won\'t Hate podcast]',
        button_link: 'https://apisyouwonthate.com/podcast/an-api-to-abstract-everything/',
        button_text: 'Listen to the podcast',
        // image_url: '/images/apis-you-wont-hate-light@1x.png',
        // image_40: true,
    },
    {
        title: 'July 3, 2023: Founder Wisdom: API startups, exits and Roy Pereira [Charles Cormier Podcast]',
        button_link: 'https://www.youtube.com/watch?v=3r4G9Utwk6o',
        button_text: 'Watch the video',
    }
];


const TEAM = [
    {
        name: 'Roy Pereira',
        title: 'CEO & co-founder',
        linkedin_url: 'https://www.linkedin.com/in/roypereira/',
        image_url: '/images/roy.webp',
    },
    {
        name: 'Alexey Adamsky',
        title: 'CTO & co-founder',
        linkedin_url: 'https://www.linkedin.com/in/alkasai/',
        image_url: '/images/alexey.webp',
    },
    {
        name: 'Michelle Tomicic',
        title: 'Head of Sales',
        linkedin_url: 'https://www.linkedin.com/in/michelle-tomicic/',
        image_url: '/images/michelle.webp',
    },
];
</script>